<template>
    <div>
        <div class="flex justify-end">
            <SyllabusContentCreateForm
                :categories="categories"
                :grade-levels="gradeLevels"
                @include-new-content="includeNewContent()"
            />
        </div>
        <div v-if="summary.length">
            <div v-for="(category, index) in summary" class="flex flex-col mt-5" :key="index">
                {{ category.name }}
                <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                    <div
                        class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                    >
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                                <tr>
                                    <th
                                        class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $tc('messages.dimensions', 2) }}
                                    </th>
                                    <th
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $tc('messages.competences', 2) }}
                                    </th>
                                    <th
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ $tc('messages.syllabus_contents', 2) }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                    v-for="dimension in category.dimensions"
                                    :key="`${dimension.counter}_${dimension.title}`"
                                >
                                    <td
                                        class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                    >
                                        <BadgePill>
                                            {{ dimension.counter }}
                                        </BadgePill>
                                        {{ dimension.abbreviation }} -
                                        {{ dimension.title }}
                                    </td>
                                    <td class="max-w-sm px-6 py-4 text-sm leading-5 font-medium text-gray-900">
                                        <div
                                            v-for="competence in dimension.competences"
                                            :key="`${competence.counter}_${competence.description}`"
                                        >
                                            <BadgePill>
                                                {{ competence.counter }}
                                            </BadgePill>
                                            {{ competence.abbreviation }} -
                                            {{ competence.description }}
                                        </div>
                                    </td>
                                    <td
                                        class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                    >
                                        <!--                                @foreach($dimension['syllabusContents'] as $syllabusContents)-->
                                        <div
                                            v-for="syllabusContent in dimension.syllabusContents"
                                            :key="`${syllabusContent.abbreviation}_${syllabusContent.title}`"
                                        >
                                            {{ syllabusContent.abbreviation }} -
                                            {{ syllabusContent.title }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <Tabs class="mt-5" :default-index="categories.findIndex((c) => c.id === activity.category_id)">
            <Tab :title="category.name" v-for="category in categories" :key="category.id">
                {{ category.name }}
                <div v-if="category.syllabusContents.length === 0" class="flex flex-col mt-5">
                    <EmptyState :title="$t('messages.no_syllabus_contents_in_domain')" with-icon with-button>
                        <template v-slot:button>
                            <SyllabusContentCreateForm
                                :categories="categories"
                                :grade-levels="gradeLevels"
                                :category="category.id"
                                @include-new-content="includeNewContent()"
                            />
                        </template>
                    </EmptyState>
                </div>
                <div v-else class="flex flex-col mt-5">
                    <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                        <div
                            class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                        >
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead>
                                    <tr>
                                        <th
                                            class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        ></th>
                                        <th
                                            class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            #
                                        </th>
                                        <th
                                            class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $tc('messages.syllabus_contents', 1) }}
                                        </th>
                                        <th
                                            class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                        >
                                            {{ $tc('messages.competences', 2) }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(syllabusContent, index) in category.syllabusContents"
                                        :key="`${syllabusContent.number}_${syllabusContent.title}`"
                                        :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                    >
                                        <td
                                            class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                        >
                                            <input
                                                type="checkbox"
                                                name="syllabus_content_ids[]"
                                                v-model="syllabus_content_ids"
                                                :value="syllabusContent.id"
                                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                            />
                                        </td>
                                        <td
                                            class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                        >
                                            <InertiaSquareLinkButton action="edit" :href="syllabusContent.links.edit" />
                                            {{ syllabusContent.number }}
                                        </td>
                                        <td class="max-w-sm px-6 py-4 text-sm leading-5 font-medium text-gray-900">
                                            {{ syllabusContent.title }}
                                        </td>
                                        <td class="max-w-sm px-6 py-4 text-sm leading-5 font-medium text-gray-900">
                                            <ul>
                                                <li
                                                    v-for="competence in getCompetences(syllabusContent, category)"
                                                    :key="`${competence.abbreviation}_${competence.description}`"
                                                >
                                                    <b>{{ competence.abbreviation }}</b>
                                                    -
                                                    {{ competence.description }}
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Tab>
        </Tabs>

        <form :action="activity.links.update" method="post" @submit.prevent="submit" class="mt-5">
            <div class="flex justify-end">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="false" />
            </div>
        </form>
    </div>
</template>

<script>
import Tab from '@/components/Tab.vue';
import Tabs from '@/components/Tabs.vue';
import BadgePill from '@/components/BadgePill.vue';
import SyllabusContentCreateForm from '@/components/pageSpecific/Syllabus/SyllabusContentCreateForm.vue';
import EmptyState from '@/components/EmptyState.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        BadgePill,
        Tab,
        Tabs,
        SyllabusContentCreateForm,
        EmptyState,
        InertiaSquareLinkButton,
    },
    name: 'ActivitySyllabusContentsSelector',
    props: {
        categories: { required: true, type: Array },
        activity: { required: true, type: Object },
        gradeLevels: { required: true, type: Array },
        newSyllabusContentId: { required: false, type: Number },
    },
    data() {
        return {
            syllabus_content_ids: this.activity.syllabus_content_ids,
        };
    },
    methods: {
        includeNewContent() {
            if (this.newSyllabusContentId !== null) {
                this.syllabus_content_ids.push(this.newSyllabusContentId);
            }
        },
        submit() {
            this.$inertia.patch(this.activity.links.update, {
                syllabus_contents: this.syllabus_content_ids,
            });
        },
        getCompetences(syllabusContent, category) {
            return category.dimensions
                .flatMap((d) => d.competences)
                .filter((c) => syllabusContent.competences_ids.includes(c.id));
        },
    },
    computed: {
        competences_ids: function () {
            return this.categories
                .flatMap((c) => c.syllabusContents)
                .filter((kc) => this.syllabus_content_ids.includes(kc.id))
                .flatMap((kc) => kc.competences_ids);
        },
        selectedSyllabusContents: function () {
            return this.categories
                .flatMap((c) => c.syllabusContents)
                .filter((kc) => this.syllabus_content_ids.includes(kc.id));
        },
        summary: function () {
            if (this.syllabus_content_ids.length === 0) {
                return [];
            }

            const map = new Map();
            this.selectedSyllabusContents.forEach((sc) => {
                sc.dimensions_ids.forEach((d) => {
                    if (!map.has(d)) {
                        map.set(d, []);
                    }
                    const dimensionEntry = map.get(d);
                    dimensionEntry.push(sc);
                    map.set(d, dimensionEntry);
                });
            });

            const categories = JSON.parse(JSON.stringify(this.categories));

            for (let i = 0; i < categories.length; i++) {
                for (let j = 0; j < categories[i].dimensions.length; j++) {
                    const dimensionId = categories[i].dimensions[j].id;
                    if (map.has(dimensionId)) {
                        categories[i].dimensions[j].syllabusContents = map.get(dimensionId);
                    } else {
                        categories[i].dimensions[j].syllabusContents = [];
                    }
                    for (let k = 0; k < categories[i].dimensions[j].competences.length; k++) {
                        const competence_id = categories[i].dimensions[j].competences[k].id;
                        if (this.competences_ids.includes(competence_id)) {
                            const times = this.competences_ids.filter((c) => c === competence_id).length;
                            categories[i].dimensions[j].competences[k].counter += times;
                            categories[i].dimensions[j].counter += times;
                            categories[i].counter += times;
                        }
                    }
                }
            }

            return categories
                .filter((c) => c.counter > 0)
                .map((c) => {
                    c.dimensions = c.dimensions
                        .filter((d) => d.counter > 0)
                        .map((d) => {
                            d.competences = d.competences.filter((c) => c.counter > 0);
                            return d;
                        });
                    return c;
                });
        },
    },
};
</script>
